// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import radacmtEntity from './entities/radacmt.json';
import radacmtMenu from '../pages/radacmt/menu.json';
import radacmtFullForm from '../pages/radacmt/forms/full.json';
import radacmtContextForm from '../pages/radacmt/forms/context.json';
import radacmtMiniForm from '../pages/radacmt/forms/mini.json';
import radacmtLookupForm from '../pages/radacmt/forms/lookup.json';
import radacmtTableView from '../pages/radacmt/views/table.json';
import radacmtStagesView from '../pages/radacmt/views/stages.json';
import radacmtCardsView from '../pages/radacmt/views/cards.json';
import radacmtInlineView from '../pages/radacmt/views/inline.json';
import radacmtBacklogView from '../pages/radacmt/views/backlog.json';
import radacmtSplitView from '../pages/radacmt/views/split.json';
import radacmtCalendarView from '../pages/radacmt/views/calendar.json';
import radacmtDashboardView from '../pages/radacmt/views/dashboard.json';
import radacmtCmatrixView from '../pages/radacmt/views/cmatrix.json';

/** Тип запису «Комітет» зі сторінками пакета: меню, форми та подання з pages/radacmt/. */
export const radacmtDefinition: IRecordTypeDefinition = {
  ...radacmtEntity,
  views: assembleViewSet({
      table: radacmtTableView,
      stages: radacmtStagesView,
      cards: radacmtCardsView,
      inline: radacmtInlineView,
      backlog: radacmtBacklogView,
      split: radacmtSplitView,
      calendar: radacmtCalendarView,
      dashboard: radacmtDashboardView,
      cmatrix: radacmtCmatrixView,
  }),
  form: radacmtFullForm,
  forms: { full: radacmtFullForm, context: radacmtContextForm, mini: radacmtMiniForm, lookup: radacmtLookupForm },
  menu: radacmtMenu,
} as IRecordTypeDefinition;
